import { type FC, type ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import CheckShield from 'dibs-icons/exports/CheckShield.ts';
import { useBuyerIncentivesMessages } from './hooks/useBuyerIncentivesMessages.tsx';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

export const Incentives: FC = () => {
    const incentives = useBuyerIncentivesMessages();

    return (
        <>
            {incentives.map((incentive, index) => (
                <div key={index} className={classnames(dibsCss.inline, dibsCss.whitespacePreWrap)}>
                    <FormattedMessage
                        id="PdpSharedSidebarBuyerIncentives.incentive"
                        defaultMessage="{isLast, select, true {{incentive}} other {{incentive}, }}"
                        values={{ incentive, isLast: index === incentives.length - 1 }}
                    />
                </div>
            ))}
        </>
    );
};

type Props = {
    getLink: (chunk: ReactNode) => ReactNode;
    linkPosition?: 'top' | 'bottom';
};
export const BuyerIncentivesBanner: FC<Props> = ({ getLink, linkPosition = 'bottom' }) => {
    return (
        <div className={classnames(dibsCss.pSmaller, dibsCss.bgShagreen50, dibsCss.roundedXxsmall)}>
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.gapXsmall,
                    dibsCss.sassyFontBodySmallHeavy,
                    dibsCss.mbXxsmall
                )}
            >
                <CheckShield variation="20" />
                <FormattedMessage
                    id="BuyerIncentivesBanner.incentives.title"
                    defaultMessage="Shop With Confidence {showLink, select, true {<link>Details</link>} other {}}"
                    values={{
                        showLink: linkPosition === 'top',
                        link: chunk => getLink(chunk),
                    }}
                />
            </div>
            <span className={classnames(dibsCss.sassyFontBodySmall)}>
                <FormattedMessage
                    id="BuyerIncentivesBanner.incentives.message"
                    defaultMessage="{incentives} {showLink, select, true {<link>Details</link>} other {}}"
                    values={{
                        incentives: <Incentives />,
                        showLink: linkPosition === 'bottom',
                        link: chunk => getLink(chunk),
                    }}
                />
            </span>
        </div>
    );
};
